import { IonToggle } from '@ionic/react';

import styles from './map-legend-toggle.module.css';

export interface MapLegendToggleProps {
  checked: boolean;
  label: string;
  className?: string;
  onCheckedChange: (checked: boolean) => void;
}

export function MapLegendToggle(props: MapLegendToggleProps) {
  const handleChange = (event: CustomEvent) => {
    props.onCheckedChange(event.detail.checked);
  };

  return (
    <div
      className={`${styles.toggle} mapboxgl-ctrl ${props.className ?? ''}`.trim()}
    >
      <IonToggle
        checked={props.checked}
        labelPlacement="end"
        onIonChange={handleChange}
      >
        {props.label}
      </IonToggle>
    </div>
  );
}

export default MapLegendToggle;
